// Generated by scripts/syncOnlyOfficeEnv.js — do not edit.
// Source: .env
// Keys: ONLYOFFICE_ENABLED, ONLYOFFICE_URL

const onlyOfficeEnv =
{
    enabled: true,
    url: 'https://lafayettesandboxapi.cyphersystem.com/onlyoffice-ds'
};

export { onlyOfficeEnv };
